import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { addEventListener } from '@ifeng/ui_base';
import formatThumbnail from '../../utils/formatThumbnail';

class TopicTop extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;
        const data = content && Array.prototype.isPrototypeOf(content) && content.length > 0 ? content[0] : null;

        return content && Array.prototype.isPrototypeOf(content) && content.length > 0 ? (
            <div className={styles.topicTop}>
                <a href={data.url} target="_blank">
                    <img src={formatThumbnail(data, 650, 300)} alt={data.title} />
                    <div className={styles.title}>{data.title}</div>
                </a>
            </div>
        ) : null;
    }
}

export default TopicTop;
